import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=6d43ada4&scoped=true"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=6d43ada4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d43ada4",
  null
  
)

/* custom blocks */
import block0 from "@/locales2/share/orderTimeline.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fsrc%2Fapp%2Fsrc%2Fpartner%2Fcomponents%2Frecords%2Flist_view%2FStatusBadge.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports